module.exports = __webpack_public_path__ + "static/media/ulip.3c17926f.mp3";